import React from "react"
import PropTypes from "prop-types"
import {Chip} from "@mui/material"
import theme from "../../theme/theme"

const StatusBadge = ({
    label = "Status",
    backgroundColor = "warning",
    fontColor = theme.palette.common.white,
    radius = 2
}) => {
    const paletteMap = {
        warning: theme.palette.warning.main,
        error: theme.palette.error.main,
        success: theme.palette.success.main,
    }
    const resolvedBg = paletteMap[backgroundColor] || backgroundColor

    return (
    <Chip
        label={label}
        sx={{
            backgroundColor: resolvedBg,
            color: fontColor,
            fontWeight: 400,
            fontSize: ".9rem",
            height: 28,
            borderRadius: radius,
            textTransform: "uppercase",
        }}
    />
)}

StatusBadge.propTypes = {
    label: PropTypes.string,
    backgroundColor: PropTypes.string,
    fontColor: PropTypes.string,
    radius: PropTypes.number,
}

export default StatusBadge
